import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getLoggedUserDetails } from './Actions/UserAction';
import { GET_LOGGED_USER_DETAILS } from './ActionTypes/ActionTypes';
import { LocalStorageKeys } from './Components/QuoteRequest/Content';
import { Congiguration } from './Constants/AppConstants';
import { isJsonString } from './Helper/Helper';

let lastNetworkErrorAt = 0;
const NETWORK_ERROR_THROTTLE_MS = 10000;

const notifyNetworkIssue = (error, serviceName = 'service') => {
    const isNetworkError = error?.code === 'ERR_NETWORK' || !error?.response;
    if (!isNetworkError) {
        return;
    }

    const now = Date.now();
    if (now - lastNetworkErrorAt < NETWORK_ERROR_THROTTLE_MS) {
        return;
    }
    lastNetworkErrorAt = now;

    window.dispatchEvent(new CustomEvent('cpq-network-error', {
        detail: {
            message: `Unable to reach ${serviceName}. Connect to Workplace Options network/VPN and try again.`
        }
    }));
};

const cpqAxiosWithoutUrlEncoding = axios.create({
    baseURL: Congiguration.CPQApi,
    paramsSerializer: {
        encode: (param) => encodeURIComponent(param).replaceAll("+", "%2B"),
    },      
});

const cpqAxios = axios.create({
    baseURL: Congiguration.CPQApi,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': Congiguration.CPQAPIMKey,
    }    
});
const cpqAxiosWithToken = axios.create({
    baseURL: Congiguration.CPQApi,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': Congiguration.CPQAPIMKey,
    }       
});
cpqAxiosWithToken.interceptors.request.use(
   async (config) => {
        //CheckAndUpdateUser();
        const lStorage = sessionStorage.getItem('cpqtoken');
        if (lStorage !== undefined && lStorage !== null && lStorage !== 'null' && lStorage !== 'undefined')
        {
            const token = JSON.parse(sessionStorage.getItem('cpqtoken')).token;
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        else {
            try {
                const newAccessToken = await generateAccessToken();
               // const newAccessToken = await refreshAccessToken();
                sessionStorage.setItem('cpqtoken', JSON.stringify(newAccessToken));
                //if (lStorage) {
                    const token = JSON.parse(sessionStorage.getItem('cpqtoken')).token;
                    if (token) {
                        config.headers['Authorization'] = `Bearer ${token}`;
                    }
               
            } catch (refreshError) {
                // If token refresh fails, redirect to the login page or handle it as needed
                console.error('Token refresh failed:', refreshError);
                notifyNetworkIssue(refreshError, 'CPQ API');
                // Redirect or handle the error as needed
            }
            
        }
        return config;
    },

        (error) => {
            return Promise.reject(error);
        }
);

cpqAxiosWithToken.interceptors.response.use(
    (response) => response,
    async (error) => {
        //CheckAndUpdateUser();
        const originalRequest = error.config;
        const statusCode = error?.response?.status;

        // Check if the error is due to an expired token
        if ((statusCode === 401 || statusCode === 403) && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Refresh the access token
                const newAccessToken = await generateAccessToken();
                sessionStorage.setItem('cpqtoken', JSON.stringify(newAccessToken));
                // Update the original request with the new token
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

                // Retry the original request with the new token
                return cpqAxiosWithToken(originalRequest);
            } catch (refreshError) {
                // If token refresh fails, redirect to the login page or handle it as needed
                console.error('Token refresh failed:', refreshError);
                notifyNetworkIssue(refreshError, 'CPQ API');
                // Redirect or handle the error as needed
            }
        }

        return Promise.reject(error);
    }
);


const generateAccessToken = async () => {
    try {
        const schedulerClients = {
            ClientName: Congiguration.ClientName,
            Password: Congiguration.Passcode,
        };

        const resp = await cpqAxios.post("User/GenerateToken", schedulerClients);
        // Make a request to your authentication server to refresh the token
        //customFetch.get("auth/refresh");
        console.info("CPQ token generated successfully");
        return resp.data;
    } catch (error) {
        // Handle errors (e.g., token refresh failed)
        console.error('Token generation failed', error);
        notifyNetworkIssue(error, 'CPQ API');
        throw error;
    }
};

const crmAxiosWithToken = axios.create({
    baseURL: Congiguration.CRMApi,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': Congiguration.CRMAPIMKey,
    }

    
});
crmAxiosWithToken.interceptors.request.use(
    async (config) => {

        //CheckAndUpdateUser();

        const lStorage = sessionStorage.getItem('crmtoken');
        if (lStorage !== undefined && lStorage !== null && lStorage !== 'null' && lStorage !== 'undefined') {
            const token = JSON.parse(sessionStorage.getItem('crmtoken')).token;
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        else {
            try {
                const newAccessToken = await CrmGenerateAccessToken();
                // const newAccessToken = await refreshAccessToken();
                sessionStorage.setItem('crmtoken', JSON.stringify(newAccessToken));
                //if (lStorage) {
                const token = JSON.parse(sessionStorage.getItem('crmtoken')).token;
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }

            } catch (refreshError) {
                // If token refresh fails, redirect to the login page or handle it as needed
                console.error('Crm Token refresh failed:', refreshError);
                notifyNetworkIssue(refreshError, 'CRM API');
                // Redirect or handle the error as needed
            }

        }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

crmAxiosWithToken.interceptors.response.use(
    (response) => response,
    async (error) => {

        //CheckAndUpdateUser();

        const originalRequest = error.config;
        const statusCode = error?.response?.status;

        // Check if the error is due to an expired token
        if ((statusCode === 401 || statusCode === 403) && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Refresh the access token
                const newAccessToken = await CrmGenerateAccessToken();
                sessionStorage.setItem('crmtoken', JSON.stringify(newAccessToken));
                // Update the original request with the new token
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

                // Retry the original request with the new token
                return crmAxiosWithToken(originalRequest);
            } catch (refreshError) {
                // If token refresh fails, redirect to the login page or handle it as needed
                console.error('Token refresh failed:', refreshError);
                notifyNetworkIssue(refreshError, 'CRM API');
                // Redirect or handle the error as needed
            }
        }

        return Promise.reject(error);
    }
);

const CrmGenerateAccessToken = async () => {
    try {
        const schedulerClients = {
            ClientName: Congiguration.CRMApiClientName,
            Password: Congiguration.CRMApiPassword,
        };

        const resp = await crmAxiosWithoutToken.post("User/GenerateToken", schedulerClients);
        // Make a request to your authentication server to refresh the token
        //customFetch.get("auth/refresh");
        console.info("CRM token generated successfully");
        return resp.data;
    } catch (error) {
        // Handle errors (e.g., token refresh failed)
        console.error('Token generation failed', error);
        notifyNetworkIssue(error, 'CRM API');
        throw error;
    }
};

//const CheckAndUpdateUser = () => {
//    const loggedUserLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) : null;    
//    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
//    const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
    
//    const dispatch = useDispatch();

//    if (loggedUser !== undefined && Object.keys(loggedUser).length === 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {
//        loggedUser = loggedUserLocalStorage;
//    } else {
//        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
//            dispatch(getLoggedUserDetails(useremail))
//                .then((response) => {
//                    const jsonUserData = JSON.stringify(response);
//                    sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
//                    //storing user login to reducer
//                    dispatch({
//                        type: GET_LOGGED_USER_DETAILS,
//                        payload: response,
//                    });
//                })
//                .catch((error) => {
//                    console.log(`userEmail : ${useremail} error : ${error}`);
//                });
//        }
//    }
//}

const crmAxiosWithoutToken = axios.create({
    baseURL: Congiguration.CRMApi,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': Congiguration.CRMAPIMKey,
    }
  
});
export {
    cpqAxios,
    crmAxiosWithoutToken,
    cpqAxiosWithToken,
    crmAxiosWithToken,
    cpqAxiosWithoutUrlEncoding
};